import { BaseAPI } from 'API/BaseApi';
import { eAPITags } from 'API/eAPITags';
import { ICreateFeeRequest } from 'types/order/fees/ICreateFeeRequest';
import { IEditFeeRequest } from 'types/order/fees/IEditFeeRequest';
import { ISectionData, ISettlementItemData } from 'types/order/fees/ISectionData';
import { ISectionDefinitionData } from 'types/order/fees/ISectionDefinition';
import { cleanupRequest } from 'API/cleanupRequests';
import { IFeeValidationData } from 'types/order/fees/IFeeValidationData';

export const FeesApi = BaseAPI.injectEndpoints({
  endpoints: (build) => ({
    getSectionDefinitions: build.query<ISectionDefinitionData[], void>({
      query: () => ({ method: 'GET', url: `/timber/api/internal/v1/feeDefinitions` }),
    }),
    getSectionData: build.query<ISectionData[], string>({
      query: (orderId) => `/timber/api/internal/v1/fees/${orderId}`,
      providesTags: (response, error, orderId) => [{ type: eAPITags.SectionData, id: orderId }],
    }),
    getCDLineLimits: build.query<IFeeValidationData[], void>({
      query: () => `/timber/api/internal/v1/cd-limits`,
    }),
    addFee: build.mutation<ISettlementItemData, ICreateFeeRequest>({
      query: ({ statementFees, ...rest }) => ({
        url: `/timber/api/internal/v1/fees`,
        method: 'POST',
        body: cleanupRequest({ ...rest, statementSettlementFees: statementFees }),
      }),
      invalidatesTags: (result, error, request) => [{ type: eAPITags.SectionData, id: request.orderId }],
    }),
    editFee: build.mutation<void, IEditFeeRequest>({
      query: ({ statementFees, ...rest }) => ({
        url: `/timber/api/internal/v1/fees`,
        method: 'PUT',
        body: cleanupRequest({ ...rest, statementSettlementFees: statementFees }),
      }),
      invalidatesTags: (result, error, request) => [{ type: eAPITags.SectionData, id: request.orderId }],
    }),
    deleteFee: build.mutation<void, { orderId: string; feeId: string }>({
      query: (request) => ({
        url: `/timber/api/internal/v1/fees/${request.feeId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, request) => [{ type: eAPITags.SectionData, id: request.orderId }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetSectionDefinitionsQuery,
  useGetSectionDataQuery,
  useGetCDLineLimitsQuery,
  useAddFeeMutation,
  useEditFeeMutation,
  useDeleteFeeMutation,
} = FeesApi;
